<template>
  <TestLayout :on-action="onHeaderAction" :on-settings-action="onSettingsAction" :on-copy-test="onCopyAction"
              :on-preview-action="()=> previewModalVisible = true" :on-tour="onTour" :active-tab="activeTab"
              :on-back="handleBack"
  >
    <div class="root-wrapper">
      <div class="top-panel">
        <div class="tab-panel-wrapper no-text-select">
          <div class="tab-panel-left">
            <div id="t-step-0" class="tab" :class="{'active': activeTab === 0}" @click="() => changeTab(0)">
              {{ $t('questions') }}
            </div>

            <div id="t-step-1" class="tab" :class="{'active': activeTab === 1}" @click="() => changeTab(1)">
              {{ $t('dimensions') }}
            </div>

            <div id="t-step-survey" v-if="testData?.type === 3" class="tab" :class="{'active': activeTab === 2}" @click="() => changeTab(2)">
              {{ $t('optionTypes.survey') }}
            </div>
          </div>

          <div id="t-step-6" class="tab-panel-right">
            <TranslationDropdown :selected-language="activeLanguage" :on-select="handleLanguageChange"/>
          </div>
        </div>

        <div class="question-select-wrapper" v-if="selectedSteps.length > 0">
          <span>{{ $t('selected') }} {{ selectedSteps.length }}</span>
          <ActionDropdown v-if="!dimensionSelectLoading" :actions="rootDimensionList" :on-action="handleSelectedAction"
                          placeholder="Select a dimension"/>
          <VueSpinnerIos v-if="dimensionSelectLoading" size="14"/>
        </div>
      </div>

      <div class="wrapper" v-if="activeTab === 0">
        <div class="left-wrapper">
          <div class="card-wrapper">
            <div class="title-card-border"></div>
            <input class="title-input w-100" :placeholder="this.$t('add_your_test')" v-model="testData.name"/>
            <input class="description-input" :placeholder="this.$t('explanation_test')" v-model="testData.description"/>
          </div>

          <div class="question-list">
            <Question
                v-for="question in testData.questions"
                :data="question"
                :on-delete="handleDelete"
                :question-update="handleQuestionUpdate"
                :on-change-position="changeOrder"
                :on-duplicate-question="duplicateQuestion"
                :key="question.order + forceRerender"
                :tag-list="tagsData"
                :dimension-list="dimensionsData"
                :question-list="testData.questions"
                v-model:deleteList="deleteList"
                :ai-socket="aiSocket"
            />
          </div>
          <div class="bottom-actions">
            <div class="add-question-button no-text-select" @click="addQuestion">
              <img src="@/assets/images/plus.svg"/>
              <span>{{ $t('add_a_question') }}</span>
            </div>
          </div>
        </div>
        <div id="t-step-7" class="right-wrapper">
          <div class="card-wrapper">
            <div class="header-wrapper">
              <h3>{{ $t('steps') }}</h3>

              <div class="color-tool-wrapper">
                <template v-for="dimensionKey in Object.keys(colorFilter)">
                  <div class="color-tool" :style="{backgroundColor: colorFilter[dimensionKey].color}"
                       v-tooltip="getDimensionDame(dimensionKey)"
                       @click="selectIds(colorFilter[dimensionKey].questions)"/>
                </template>
              </div>
            </div>

            <div class="question-list-right">
              <draggable
                  v-model="testData.questions"
                  item-key="order"
                  @end="updateOrder"
              >
                <template #item="{element}">
                  <div class="question-block-row">
                    <img src="@/assets/images/drag.svg"/>
                    <div class="question-block" :class="selectedSteps.includes(element.order) && 'selected'"
                         @click="handleToggleStep(element.order)">
                      <div class="question-indicator" :style="{backgroundColor: getColorCode(element.questionId)}"/>
                      <div class="question-number">
                        <img v-if="selectedSteps.includes(element.order)" src="@/assets/images/checkCircle.svg">
                        <img v-else src="@/assets/images/checkBlank.svg">
                        {{ $t('question_type_program') }} {{ element.order }}
                      </div>
                      <div class="question-title" v-if="element.name !== '' && element.name">
                        {{ element.name.substr(0, 30) }}...
                      </div>
                    </div>
                  </div>
                </template>
              </draggable>
            </div>
          </div>
        </div>
      </div>

      <div class="wrapper" v-if="activeTab === 1">
        <div class="left-wrapper">

          <div class="dimension-list">
            <QuestionDimension
                v-for="(dimension, index) in dimensionsData"
                :key="dimension.dimensionalId"
                :data="dimension"
                :index="index"
                :on-delete="handleNewDimensionDelete"
                :request-refresh="fetchDimensions"
            />
          </div>

          <div class="bottom-actions">
            <div class="add-question-button no-text-select" @click="addNewDimension">
              <img src="@/assets/images/plus.svg"/>
              <span>{{ $t('add_a_dimension') }}</span>
            </div>
          </div>
        </div>

        <div class="right-wrapper">
          <div class="card-wrapper">
            <div class="header-wrapper">
              <h3>{{ $t('steps') }}</h3>

              <div class="color-tool-wrapper">
                <template v-for="dimensionKey in Object.keys(colorFilter)">
                  <div class="color-tool" :style="{backgroundColor: colorFilter[dimensionKey].color}"
                       v-tooltip="getDimensionDame(dimensionKey)"
                       @click="selectIds(colorFilter[dimensionKey].questions)"/>
                </template>
              </div>
            </div>

            <div class="question-list-right">
              <div class="question-block-row" v-for="element in testData.questions">
                <div class="question-block" :class="selectedSteps.includes(element.order) && 'selected'"
                     @click="handleToggleStep(element.order)">
                  <div class="question-indicator" :style="{backgroundColor: getColorCode(element.questionId)}"/>
                  <div class="question-number">
                    <img v-if="selectedSteps.includes(element.order)" src="@/assets/images/checkCircle.svg">
                    <img v-else src="@/assets/images/checkBlank.svg">
                    {{ $t('question_type_program') }} {{ element.order }}
                  </div>
                  <div class="question-title" v-if="element.name !== ''">{{ element.name.substr(0, 30) }}...</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>


      <div v-if="activeTab === 2">
        <div class="survey-top-actions">
          <button
              class="export-excel-btn"
              @click="exportToExcel"
              :disabled="!surveyUsers || surveyUsers.length === 0"
          >
            <img src="@/assets/images/downloadOutline.svg" alt="Download" />
            <span>Excel</span>
          </button>
        </div>

        <div class="survey-container">
          <div class="users-sidebar">
            <h3>{{ $t('survey_user') }}</h3>
            <div class="user-list">
              <div v-for="(user, index) in surveyUsers" :key="user.user.userId"
                   class="user-item"
                   :class="{'active': selectedUser && selectedUser.user.userId === user.user.userId}"
                   @click="selectUser(user)">
                <span class="user-name">{{user.user?.name}}</span>
                <span class="user-email">{{user.user?.email}}</span>
              </div>
            </div>
          </div>

          <div class="answers-section">
            <h3>{{ $t('questions_answers') }}</h3>
            <div v-if="selectedUser" class="answers-list">
              <div v-for="question in sortedQuestions" :key="question.questionId" class="answer-item">
                <div class="question-text">
                  <span class="question-id">{{ $t('questions_subtitle') }}{{ question.order }}: </span>
                  {{ question.name }}
                </div>
                <div class="answer-text">{{ getAnswerForQuestion(question) }}</div>
              </div>
            </div>
            <div v-else class="no-user-selected">
              {{ $t('select_user_to_see_answers') }}
            </div>
          </div>
        </div>
      </div>

      <v-tour name="testTour" :steps="testTourSteps" :options="labels"></v-tour>

    </div>
    <TestPreviewModal
        :visible="previewModalVisible"
        :on-hide="hidePreviewModal"
        :test-data="this.testData"
    />
    <LoadingOverlay :is-loading="isLoading"/>
    <TestSettingsModal :visible="testSettingsVisible" :on-hide="() => testSettingsVisible = false"
                       :settings="testData"/>

    <UnsavedChangesModal
        :is-visible="showUnsavedModal"
        :is-loading="isLoading"
        @save="handleUnsavedSave"
        @discard="handleUnsavedDiscard"
    />
  </TestLayout>
</template>

<script>
import * as XLSX from 'xlsx';
import Question from "@/components/Question.vue";
import TestLayout from "@/components/layouts/TestLayout.vue";
import testService from "@/service/testService";
import draggable from 'vuedraggable'
import {VueSpinnerCore, VueSpinnerIos} from 'vue3-spinners'
import {colorPalette, handleErrorResponse} from "@/utils/utils";
import TestSettingsModal from "@/components/modals/TestSettingsModal.vue";
import commonService from "@/service/commonService";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import testDimensionService from "@/service/testDimensionService";
import QuestionDimension from "@/components/QuestionDimension.vue";
import ActionDropdown from "@/components/ActionDropdown.vue";
import TranslationDropdown from "@/components/TranslationDropdown.vue";
import aiSocket from '@/utils/aiSocket';
import ProgramLayout from "@/components/layouts/ProgramLayout.vue";
import TestPreviewModal from "@/components/modals/TestPreviewModal.vue";
import UnsavedChangesModal from "@/components/modals/UnsavedChangesModal.vue";
import fileService from "@/service/fileService";
import GameCard from "@/components/GameCard.vue";
import programService from "@/service/programService";

export default {
  components: {
    GameCard,
    TestPreviewModal,
    ProgramLayout,
    TranslationDropdown,
    ActionDropdown,
    LoadingOverlay,
    TestSettingsModal,
    TestLayout,
    Question,
    QuestionDimension,
    VueSpinnerCore,
    VueSpinnerIos,
    draggable,
    UnsavedChangesModal
  },
  data() {
    return {
      labels: this.tourConfig,
      testTourSteps: [
        {
          target: '#t-step-2',
          content: this.$t("testTour.step2"),
          params: {
            placement: 'bottom',
            highlight: true
          }
        },
        {
          target: '#t-step-3',
          content: this.$t("testTour.step3"),
          params: {
            placement: 'bottom',
            highlight: true
          }
        },
        {
          target: '#t-step-4',
          content: this.$t("testTour.step4"),
          params: {
            placement: 'bottom',
            highlight: true
          }
        },
        {
          target: '#t-step-5',
          content: this.$t("testTour.step5"),
          params: {
            placement: 'bottom',
            highlight: true
          }
        },
        {
          target: '#t-step-6',
          content: this.$t("testTour.step6"),
          params: {
            placement: 'bottom',
            highlight: true
          }
        },

        {
          target: '#t-step-0',
          content: this.$t("testTour.step0"),
          params: {
            placement: 'top',
            highlight: true
          }
        },
        {
          target: '#t-step-1',
          content: this.$t("testTour.step1"),
          params: {
            placement: 'top',
            highlight: true
          }
        },
        {
          target: '#t-step-survey',
          content: this.$t("testTour.step12"),
          params: {
            placement: 'top',
            highlight: true
          }
        },
        {
          target: '#t-step-7',
          content: this.$t("testTour.step7"),
          params: {
            placement: 'left',
            highlight: true
          }
        }
      ],
      deleteList: [],
      aiSocket,
      previewModalVisible: false,
      isLoading: true,
      editMode: false,
      activeLanguage: "tr",
      questions: [{
        questionNumber: "1",
        questionTitle: "",
      }],
      testData: {
        name: "",
        description: "",
        shortDescription: "",
        startAt: null,
        finishAt: null,
        isRetry: false,
        retryTime: 90,
        isPublish: false,
        isRandom: false,
        questions: [],
        type: 1
      },
      selectedSteps: [],
      dimensionSelectLoading: false,
      tagsData: [],
      dimensionsData: [],
      rootDimensionList: [
        {
          name: 'Add a dimension first',
          action: '-1'
        }
      ],
      testSettingsVisible: false,
      activeTab: 0,
      lastOrder: 0,
      forceRerender: 0,
      colorFilter: {},
      uploadStatus: [],

      surveyUsers: [],
      surveyAnswers: [],
      selectedUser: null,
      showUnsavedWarning: false,
      showUnsavedModal: false
    }
  },
  computed: {
    sortedQuestions() {
      if (!this.selectedUser || !this.selectedUser.questions) return [];
      return [...this.selectedUser.questions].sort((a, b) => a.order - b.order);
    }
  },
  watch: {
    "testData.description": function (newVal, oldVal) {
      this.testData.shortDescription = newVal.substring(0, 100);
    },
    testData: {
      handler(newVal, oldVal) {
        if (this.isLoading) return;
        this.showUnsavedWarning = true;
      },
      deep: true
    },
  },
  mounted() {
    const routeParams = this.$route.params;

    if (routeParams.id !== "new") {
      this.handleGetDetail();
    } else {
      this.addQuestion();
      this.$nextTick(() => {
        this.isLoading = false;
        this.showUnsavedWarning = false;
      });
    }
    this.fetchTags();
    aiSocket.connect();
  },
  unmounted() {
    aiSocket.disconnect();
  },
  methods: {
    hidePreviewModal() {
      this.previewModalVisible = false;
    },
    handleBack() {
      console.log('handleBack called, showUnsavedWarning:', this.showUnsavedWarning);
      if (this.showUnsavedWarning) {
        this.showUnsavedModal = true;
      } else {
        this.$router.push('/tests');
      }
    },
    handleUnsavedSave() {
      this.showUnsavedModal = false;
      if (this.editMode) {
        this.updateTest(true);
      } else {
        this.addTest(true);
      }
    },
    handleUnsavedDiscard() {
      this.showUnsavedModal = false;
      this.$router.push('/tests');
    },
    handleGetDetail() {
      const routeParams = this.$route.params;

      this.isLoading = true;
      this.editMode = true;
      testService.getTestDetail(routeParams.id, this.activeLanguage).then((response) => {
        this.testData = response.data.data;

        if (this.testData.isPublish && (!this.testData.publishedLanguages || Array.isArray(this.testData.publishedLanguages))) {
          this.testData.publishedLanguages = {
            tr: 1,
            en: 0
          };
        }

        this.fetchDimensions();
        this.handleTestGet();
        this.handleGetSurveyAnswers();
      }).catch(() => {
        this.$snackbar.add({
          text: this.$t('fetching_test_failed'),
          type: "error",
        });
      });
    },

    handleTestGet() {
      this.testData.startAt = this.formatDate(this.testData.startAt);
      this.testData.finishAt = this.formatDate(this.testData.finishAt);
      this.updateOrder();
      this.isLoading = false;
      this.$nextTick(() => {
        this.showUnsavedWarning = false;
      });
    },
    handleGetSurveyAnswers() {
      testService.getSurveyList(this.$route.params.id).then((response) => {
        this.surveyUsers = response.data.data.data.users;
      })
    },
    onSettingsAction() {
      this.testSettingsVisible = true;
    },
    onTour() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      setTimeout(() => {
        this.$tours['testTour'].start();
      }, 300);
    },
    addQuestion() {
      this.lastOrder++;

      this.testData.questions.push({
        name: "",
        status: 1,
        content: {
          type: "single",
          settings: {
            required: true,
            randomOrder: false,
            other: false,
            grading: 0
          },
          attach: [],
          options: [
            {
              id: 0,
              name: "Option A"
            },
            {
              id: 1,
              name: "Option B",
            },
          ]
        },
        order: this.lastOrder,
        waitingTime: null
      });
    },

    fetchTags() {
      commonService.getTags().then((res) => {
        this.tagsData = res.data.data.tag.map((tag) => {
          return {
            id: tag.id,
            name: tag.name,
          }
        });
      });
    },
    async fetchDimensions() {
      if (!this.testData.testId) {
        return;
      }

      await testDimensionService.getDimensions(this.testData.testId).then((res) => {
        this.dimensionsData = res.data.data;
        this.rootDimensionList = this.dimensionsData.filter((dimension) => dimension.type === 'root').map((dimension, index) => {
          this.colorFilter[dimension.dimensionalId] = {
            questions: dimension?.questions,
            color: colorPalette[index]
          };

          return {
            name: dimension.name,
            action: dimension.dimensionalId
          }
        });

        if (this.dimensionsData.length === 0) {
          this.rootDimensionList = [
            {
              name: 'Add a dimension first',
              action: '-1'
            }
          ];
        }
      }).catch(error => {
        handleErrorResponse(error, this.$snackbar);
      });
    },
    handleDelete(orderId) {
      const foundQuestion = this.testData.questions.find(
          (question) => question.order === orderId
      );

      if (foundQuestion) {
        const index = this.testData.questions.indexOf(foundQuestion);
        this.testData.questions.splice(index, 1);
      }

      this.updateOrder();
    },
    onHeaderAction() {
      let allFalse = true;
      if (this.uploadStatus && this.uploadStatus.length > 0) {
        allFalse = this.uploadStatus.every(status => {
          return Object.values(status)[0] === false;
        });
      }

      if (allFalse) {
        if (this.editMode) {
          this.updateTest();
        } else {
          this.addTest();
        }
        for (let id of this.deleteList) {
          if (id !== undefined && id !== null) {
            fileService.deleteFile(id);
          }
        }
        this.deleteList = [];

      } else {
        this.$snackbar.add({
          text: this.$t('wait_for_files_to_be_uploaded'),
          type: "error",
        });
      }
    },
    handleQuestionUpdate(data) {
      const foundQuestion = this.testData.questions.find(
          (question) => question.order === data.order
      );

      if (foundQuestion) {
        const index = this.testData.questions.indexOf(foundQuestion);
        this.testData.questions[index] = data;
      }
    },
    addTest(redirectAfterSave = false) {
      this.isLoading = true;
      testService.addTest(this.testData, this.activeLanguage).then((response) => {
        this.$snackbar.add({
          text: this.$t('test_added_successfully'),
          type: "success",
        });
        this.showUnsavedWarning = false;
        if (redirectAfterSave) {
          this.isLoading = false;
          this.$router.push('/tests');
          return;
        }
        window.location.href = "/test/" + response.data.data.testId;
      }).catch((error) => {
        this.isLoading = false;
        handleErrorResponse(error, this.$snackbar);
      });
    },
    addNewDimension() {
      if (!this.testData.testId) {
        this.$snackbar.add({
          text: this.$t('please_save_the_test_first'),
          type: "warning",
        });
        return;
      }

      this.dimensionsData.push({
        isNew: true,
        type: 'root',
        testId: this.testData.testId,
        name: '',
        description: '',
        shortDescription: '',
        strengthsExplanation: '',
        developmentAreasExplanation: '',
        score: 0
      });
    },

    updateTest(redirectAfterSave = false) {
      this.isLoading = true;

      if (this.testData.isPublish && this.testData.isPublish !== "0" && this.testData.isPublish !== false) {
        if (!this.testData.publishedLanguages || Array.isArray(this.testData.publishedLanguages) || typeof this.testData.publishedLanguages !== 'object') {
          this.testData.publishedLanguages = {
            tr: 1,
            en: 0
          };
        }

        if (this.testData.publishedLanguages.tr !== 1 && this.testData.publishedLanguages.en !== 1) {
          this.testData.publishedLanguages.tr = 1;
        }
      }

      testService.updateTest(this.testData, this.activeLanguage).then((response) => {
        this.isLoading = false;
        this.showUnsavedWarning = false;
        this.$snackbar.add({
          text: this.$t('test_updated_successfully'),
          type: "success",
        });
        if (redirectAfterSave) {
          this.$router.push('/tests');
          return;
        }
        this.testData = response.data.data;
        this.handleTestGet();
      }).catch((error) => {
        this.isLoading = false;
        handleErrorResponse(error, this.$snackbar);
      });
    },

    updateOrder() {
      const updatedQuestions = [...this.testData.questions];

      updatedQuestions.forEach((question, index) => {
        question.order = index + 1;
      });

      this.testData.questions = updatedQuestions;
      this.lastOrder = this.testData.questions.length;
      this.forceRerender++;
    },
    changeOrder(dir, orderId) {
      if (this.testData.questions.length === 1) {
        return;
      }

      if (orderId === 1 && dir === 'up') {
        return;
      }

      if (orderId === this.testData.questions.length && dir === 'down') {
        return;
      }

      const arr = this.testData.questions;
      const index = arr.findIndex(item => item.order === orderId);

      if (dir === 'up' && index > 0) {
        [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];

        const tempOrder = arr[index - 1].order;
        arr[index - 1].order = arr[index].order;
        arr[index].order = tempOrder;


        this.testData.questions = [...arr];
      } else if (dir === 'down' && index < arr.length - 1) {
        [arr[index + 1], arr[index]] = [arr[index], arr[index + 1]];

        const tempOrder = arr[index + 1].order;
        arr[index + 1].order = arr[index].order;
        arr[index].order = tempOrder;

        this.testData.questions = [...arr];
      }

      this.forceRerender++;
    },
    duplicateQuestion(orderId) {
      const foundQuestion = this.testData.questions.find(
          (question) => question.order === orderId
      );

      if (foundQuestion) {
        const index = this.testData.questions.indexOf(foundQuestion);
        const newQuestion = JSON.parse(JSON.stringify(foundQuestion));
        if (newQuestion.questionId) {
          delete newQuestion.questionId;
        }
        newQuestion.order = this.testData.questions.length + 1;
        newQuestion.questionId = null;
        this.testData.questions.splice(index + 1, 0, newQuestion);
      }

      this.updateOrder();
    },
    formatDate(date) {
      const selectedDate = new Date(date);
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      const formatter = new Intl.DateTimeFormat("en-GB", options);
      return formatter.format(selectedDate).replace(/\//g, '.').replace(/[/,]/g, '');
    },
    handleToggleStep(order) {
      if (this.selectedSteps.includes(order)) {
        this.selectedSteps = this.selectedSteps.filter((step) => step !== order);
      } else {
        this.selectedSteps.push(order);
      }
    },
    changeTab(tab) {
      this.activeTab = tab;
    },
    handleSelectedAction(action) {
      if (!this.testData.testId) {
        this.$snackbar.add({
          text: this.$t('please_save_the_test_first'),
          type: "warning",
        });
        return;
      }

      if (action === '-1') {
        this.$snackbar.add({
          text: this.$t('please_add_a_dimension_first'),
          type: "warning",
        });
        return;
      }

      this.dimensionSelectLoading = true;
      const tempIds = [];

      this.selectedSteps.forEach((step) => {
        const foundQuestion = this.testData.questions.find(
            (question) => question.order === step
        );

        if (foundQuestion) {
          tempIds.push(foundQuestion.questionId);
        }
      });

      if (tempIds.includes(undefined)) {
        this.$snackbar.add({
          text: this.$t('you_have_unsaved_question'),
          type: "warning",
        });
        this.dimensionSelectLoading = false;
        return;
      }
      testDimensionService.setSelectedQuestions({
        testId: this.testData.testId,
        dimensionalId: action,
        questionIds: tempIds
      }).then(async () => {
        await this.fetchDimensions();
        this.$snackbar.add({
          text: this.$t('questions_added_to_dimension_successfully'),
          type: "success",
        });
        this.dimensionSelectLoading = false;
        this.selectedSteps = [];
      }).catch((error) => {
        this.dimensionSelectLoading = false;
        handleErrorResponse(error, this.$snackbar);
      });
    },
    handleNewDimensionDelete(data) {
      if (data.isNew) {
        const index = this.dimensionsData.indexOf(data);
        this.dimensionsData.splice(index, 1);
      }
    },
    getColorCode(questionId) {
      for (const dimensionId in this.colorFilter) {
        if (this.colorFilter.hasOwnProperty(dimensionId)) {
          const dimension = this.colorFilter[dimensionId];
          if (dimension.questions.includes(questionId)) {
            return dimension.color;
          }
        }
      }
      return '#F5F5F5';
    },
    getDimensionDame(dimensionId) {
      const dimension = this.dimensionsData.find((dimension) => dimension.dimensionalId === dimensionId);
      return dimension ? dimension.name : '';
    },
    selectIds(ids) {
      if (!ids && ids?.length <= 0) {
        return;
      }

      const tempIds = [];

      ids.map(id => {
        const question = this.testData.questions.find(question => question.questionId === id);
        if (question) {
          tempIds.push(question.order);
        }
      });

      this.selectedSteps = tempIds;

    },
    onCopyAction() {
      testService.getCopy(this.$route.params.id).then((response) => {
        this.$snackbar.add({
          text: this.$t('test_copied_successfully'),
          type: "success",
        });
        window.location.href = "/test/" + response.data.data.testId;
      }).catch((error) => {
        handleErrorResponse(error, this.$snackbar);
      });
    },
    handleLanguageChange(lang) {
      const routeParams = this.$route.params;
      this.activeLanguage = lang;

      if (routeParams.id !== "new") {
        this.handleGetDetail();
      }
    },

    selectUser(user) {
      this.selectedUser = user;
    },

    getUserInitials(name) {
      if (!name) return '';

      const nameParts = name.split(' ');
      if (nameParts.length > 1) {
        return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },
    getAnswerForQuestion(question) {
      if (!question) {
        return 'Henüz cevaplanmamış';
      }

      try {
        if (!question.answer) {
          return 'Henüz cevaplanmamış';
        }

        if (question.answer.answer === undefined || question.answer.answer === null) {
          return 'Henüz cevaplanmamış';
        }

        let answerValue = question.answer.answer;
        const questionType = question.content?.type || 'unknown';

        switch (questionType) {
          case 'single':
          case 'yesNo':
            if (question.content?.options && Array.isArray(question.content.options)) {
              const selectedOption = question.content.options.find(option =>
                  option.id == answerValue
              );
              return selectedOption ? selectedOption.name : answerValue;
            }
            return answerValue;

          case 'multiple':
            let selectedIds = [];

            if (Array.isArray(answerValue)) {
              selectedIds = answerValue.map(item => {
                if (typeof item === 'object' && item !== null) {
                  return item.answer ?? item.id ?? item.optionId ?? item.value;
                }
                return item;
              }).filter(id => id !== undefined && id !== null);
            } else if (typeof answerValue === 'string') {
              if (answerValue.includes(',')) {
                selectedIds = answerValue.split(',').map(item => item.trim());
              } else {
                selectedIds = [answerValue];
              }
            } else {
              selectedIds = [answerValue];
            }

            if (question.content?.options && Array.isArray(question.content.options)) {
              const selectedOptions = question.content.options
                  .filter(option => selectedIds.some(id => String(id) === String(option.id)))
                  .map(option => option.name || option.text || `Option ${option.id}`);

              return selectedOptions.length > 0 ? selectedOptions.join(', ') : 'Henüz cevaplanmamış';
            }

            return selectedIds.join(', ') || 'Henüz cevaplanmamış';

          case 'text':
          case 'summary':
          case 'fillTheBlank':
            return answerValue;

          case 'number':
          case 'rating':
          case 'grading':
            const minValue = question.content?.settings?.limitedRange?.min;
            const maxValue = question.content?.settings?.limitedRange?.max;

            if (minValue !== undefined && maxValue !== undefined) {
              return `${answerValue} / ${maxValue}`;
            }

            return answerValue;

          case 'D&D':
          case 'dragAndDrop':
            if (!answerValue) {
              return 'Henüz cevaplanmamış';
            }

            let dndData = answerValue;

            if (typeof dndData === 'string') {
              try {
                dndData = JSON.parse(dndData);
              } catch (e) {
                return dndData;
              }
            }

            if (Array.isArray(dndData) && dndData.length > 0) {
              const mappings = dndData.map(mapping => {
                const dragId = mapping.dragId || mapping.drag || mapping.source || mapping.from;
                const dropId = mapping.dropId || mapping.drop || mapping.target || mapping.to;

                let dragText = dragId;
                let dropText = dropId;

                const dragItems = question.content?.dragItems || question.content?.sourceItems;
                const dropZones = question.content?.dropZones || question.content?.targetItems;

                if (Array.isArray(dragItems)) {
                  const dragItem = dragItems.find(item => item.id == dragId);
                  if (dragItem) {
                    dragText = dragItem.text || dragItem.name || dragItem.value || dragId;
                  }
                }

                if (Array.isArray(dropZones)) {
                  const dropZone = dropZones.find(zone => zone.id == dropId);
                  if (dropZone) {
                    dropText = dropZone.text || dropZone.name || dropZone.value || dropId;
                  }
                }

                return `${dragText} => ${dropText}`;
              });

              return mappings.join('\n');
            }

            return 'Henüz cevaplanmamış';

          case 'Match':
          case 'matchType':
            if (!answerValue) {
              return 'Henüz cevaplanmamış';
            }

            let matchData = answerValue;

            if (typeof matchData === 'string') {
              try {
                matchData = JSON.parse(matchData);
              } catch (e) {
                return matchData;
              }
            }

            if (Array.isArray(matchData) && matchData.length > 0) {
              const matches = matchData.map(match => {
                const leftId = match.leftId || match.left || match.source || match.from;
                const rightId = match.rightId || match.right || match.target || match.to;

                let leftText = leftId;
                let rightText = rightId;

                const leftItems = question.content?.leftItems || question.content?.sourceItems || question.content?.options;
                const rightItems = question.content?.rightItems || question.content?.targetItems || question.content?.options;

                if (Array.isArray(leftItems)) {
                  const leftItem = leftItems.find(item => item.id == leftId);
                  if (leftItem) {
                    leftText = leftItem.text || leftItem.name || leftItem.value || leftId;
                  }
                }

                if (Array.isArray(rightItems)) {
                  const rightItem = rightItems.find(item => item.id == rightId);
                  if (rightItem) {
                    rightText = rightItem.text || rightItem.name || rightItem.value || rightId;
                  }
                }

                return `${leftText} — ${rightText}`;
              });

              return matches.join('\n');
            }
            return 'Henüz cevaplanmamış';

          default:
            if (!answerValue || (typeof answerValue === 'object' && Object.keys(answerValue).length === 0)) {
              return 'Henüz cevaplanmamış';
            }

            return typeof answerValue === 'object' ? JSON.stringify(answerValue) : answerValue;
        }
      } catch (error) {
        return 'Henüz cevaplanmamış';
      }
    },

    async exportToExcel() {
      if (!this.surveyUsers?.length) {
        this.showError("Export edilecek veri bulunamadı");
        return;
      }

      if (!this.testData?.name) {
        this.showError("Test bilgileri eksik");
        return;
      }

      this.isLoading = true;

      try {
        const wb = XLSX.utils.book_new();

        const mainData = await this.createMainReport();
        const questionsData = await this.createQuestionsList();

        if (!mainData?.length) {
          throw new Error("Ana rapor verisi oluşturulamadı");
        }

        const mainSheet = XLSX.utils.json_to_sheet(mainData);
        const questionsSheet = XLSX.utils.json_to_sheet(questionsData);

        XLSX.utils.book_append_sheet(wb, mainSheet, this.sanitizeSheetName('Ana Rapor'));
        XLSX.utils.book_append_sheet(wb, questionsSheet, this.sanitizeSheetName('Sorular'));

        const fileName = this.createSafeFileName();

        XLSX.writeFile(wb, fileName);

        this.showSuccess("Excel dosyası başarıyla indirildi");

      } catch (error) {
        this.showError(`Excel export başarısız: ${error.message}`);
      } finally {
        this.isLoading = false;
      }
    },

    async createMainReport() {
      const data = [];
      const maxRows = 10000;
      let rowCount = 0;

      for (const user of this.surveyUsers) {
        if (rowCount >= maxRows) {
          break;
        }

        const userName = this.sanitizeText(user?.user?.name) || 'Bilinmiyor';
        const userEmail = this.sanitizeText(user?.user?.email) || 'Bilinmiyor';
        const userQuestions = user?.questions || [];

        const baseInfo = {
          'Kullanıcı': userName,
          'Email': userEmail,
          'Toplam Cevap': userQuestions.length,
          'Export Tarihi': new Date().toLocaleDateString('tr-TR')
        };

        if (userQuestions.length > 0) {
          const sortedQuestions = [...userQuestions].sort((a, b) => {
            const orderA = parseInt(a?.order) || 0;
            const orderB = parseInt(b?.order) || 0;
            return orderA - orderB;
          });

          for (const question of sortedQuestions) {
            if (rowCount >= maxRows) break;

            try {
              data.push({
                ...baseInfo,
                'Soru No': parseInt(question?.order) || 0,
                'Soru': this.sanitizeText(question?.name) || 'Soru metni yok',
                'Cevap': await this.getSafeAnswer(question),
                'Soru Tipi': this.getQuestionType(question?.content?.type)
              });
              rowCount++;
            } catch (error) {
            }
          }
        } else {
          data.push({
            ...baseInfo,
            'Soru No': 0,
            'Soru': 'Henüz cevap verilmemiş',
            'Cevap': 'Yok',
            'Soru Tipi': 'Yok'
          });
          rowCount++;
        }
      }

      return data;
    },

    async createQuestionsList() {
      if (!this.testData?.questions?.length) {
        return [{
          'Soru No': 0,
          'Soru': 'Henüz soru eklenmemiş',
          'Tip': 'Yok',
          'Seçenekler': 'Yok'
        }];
      }

      const questions = [];

      for (const question of this.testData.questions) {
        try {
          const order = parseInt(question?.order) || 0;
          const name = this.sanitizeText(question?.name) || 'Soru metni yok';
          const type = this.getQuestionType(question?.content?.type);
          const options = this.getSafeOptions(question?.content?.options);

          questions.push({
            'Soru No': order,
            'Soru': name,
            'Tip': type,
            'Seçenekler': options
          });
        } catch (error) {
        }
      }

      return questions.sort((a, b) => (a['Soru No'] || 0) - (b['Soru No'] || 0));
    },

    async getSafeAnswer(question) {
      try {
        if (!question?.answer?.answer) return 'Cevaplanmadı';

        const answer = question.answer.answer;
        const type = question?.content?.type;
        const options = question?.content?.options;

        if (typeof answer === 'string') {
          const cleanAnswer = this.sanitizeText(answer);
          if (cleanAnswer.length > 1000) {
            return cleanAnswer.substring(0, 1000) + '...';
          }
        }

        switch (type) {
          case 'single':
          case 'yesNo':
            return this.processSingleChoice(answer, options);

          case 'multiple':
            return this.processMultipleChoice(answer, options);

          case 'text':
            return this.sanitizeText(String(answer)).substring(0, 500);

          case 'number':
          case 'rating':
          case 'grading':
            const num = parseFloat(answer);
            if (isNaN(num)) return 'Geçersiz sayı';

            const minVal = question.content?.settings?.limitedRange?.min;
            const maxVal = question.content?.settings?.limitedRange?.max;

            if (minVal !== undefined && maxVal !== undefined) {
              return `${num} / ${maxVal}`;
            }

            return num;

          default:
            return this.sanitizeText(String(answer)).substring(0, 200);
        }
      } catch (error) {
        return 'Cevap işlenemedi';
      }
    },

    processSingleChoice(answer, options) {
      if (!Array.isArray(options)) return this.sanitizeText(String(answer));

      const option = options.find(opt => String(opt?.id) === String(answer));
      return option ? this.sanitizeText(option.name || option.text) : this.sanitizeText(String(answer));
    },

    processMultipleChoice(answer, options) {
      if (!Array.isArray(options)) return this.sanitizeText(String(answer));

      try {
        const answers = Array.isArray(answer) ? answer : [answer];
        const selectedOptions = options
            .filter(opt => answers.some(ans => String(opt?.id) === String(ans)))
            .map(opt => this.sanitizeText(opt?.name || opt?.text || 'Seçenek'))
            .filter(Boolean);

        return selectedOptions.length ? selectedOptions.join(', ') : 'Seçim yapılmadı';
      } catch (error) {
        return 'Çoklu seçim işlenemedi';
      }
    },

    sanitizeText(text) {
      if (!text) return '';

      return String(text)
          .replace(/[<>\"'&]/g, '')
          .replace(/\s+/g, ' ')
          .trim()
          .substring(0, 1000);
    },

    sanitizeSheetName(name) {
      return String(name)
          .replace(/[\\\/\?\*\[\]]/g, '')
          .substring(0, 31);
    },

    createSafeFileName() {
      const testName = this.sanitizeText(this.testData.name) || 'Survey';
      const date = new Date().toISOString().slice(0, 10);
      const time = new Date().toTimeString().slice(0, 5).replace(':', '');

      return `${testName}_${date}_${time}.xlsx`;
    },

    getQuestionType(type) {
      const safeTypes = {
        'single': 'Tek Seçim',
        'multiple': 'Çoklu Seçim',
        'text': 'Metin',
        'number': 'Sayı',
        'yesNo': 'Evet/Hayır',
        'rating': 'Puanlama'
      };

      return safeTypes[type] || 'Bilinmiyor';
    },

    getSafeOptions(options) {
      if (!Array.isArray(options)) return 'Seçenek yok';

      try {
        return options
            .map(opt => this.sanitizeText(opt?.name || opt?.text))
            .filter(Boolean)
            .slice(0, 10)
            .join(' | ') || 'Seçenek bulunamadı';
      } catch (error) {
        return 'Seçenekler işlenemedi';
      }
    },

    showError(message) {
      this.$snackbar.add({
        text: message,
        type: "error",
      });
    },

    showSuccess(message) {
      this.$snackbar.add({
        text: message,
        type: "success",
      });
    },

    getDetailedAnswer(question) {
      if (!question?.answer) return 'Cevap yok';

      const answer = question.answer.answer;
      const questionType = question.content?.type;

      if (questionType === 'multiple' || questionType === 'D&D' || questionType === 'Match') {
        return typeof answer === 'object' ? JSON.stringify(answer) : answer;
      }

      return this.getAnswerForQuestion(question);
    },

    formatDateForFile(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${year}${month}${day}_${hours}${minutes}`;
    }
  },
}
</script>

<style scoped>
.card-wrapper {
  position: relative;
  background-color: #FFFFFF;
  border: 1px solid #EAECF0;
  border-radius: 16px;
  padding: 20px 20px 20px 28px;
  display: flex;
  flex-direction: column;
}

.title-card-border {
  position: absolute;
  height: 100%;
  width: 8px;
  top: 0;
  left: 0;
  background-color: #1C3CD5;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.wrapper {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.left-wrapper {
  width: 70%;
}

.right-wrapper {
  width: 30%;
}

h3 {
  padding: 0;
  margin: 0;
  font-family: euclid_medium, sans-serif;
  font-size: 18px;
  color: #040C2D;
}

.title-input {
  border: none;
  outline: none;
  font-family: euclid_medium, sans-serif;
  font-size: 24px;
  background-color: transparent;
  color: #040C2D;
  margin-bottom: 15px;
}

.description-input {
  border: none;
  outline: none;
  font-family: euclid_medium, sans-serif;
  font-size: 16px;
  background-color: transparent;
  color: #98A2B3;
}

.title-input:focus, .description-input:focus {
  border-bottom: 1px solid #D0D5DD;
}

.tab-panel-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.tab-panel-left {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.tab-panel-right {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.tab {
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #667085;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}

.tab.active {
  border-bottom: 2px solid #4A68F8;
  color: #4A68F8;
}

.top-panel {
  position: sticky;
  top: 64px;
  z-index: 998;
  background-color: #FCFCFD;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.question-list {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.dimension-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.question-block-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  margin-bottom: 5px;
  cursor: grab;
}

.question-block {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 10px 10px 22px;
  background-color: #FFFFFF;
  border: 1px solid #EAECF0;
  border-radius: 12px;
  position: relative;
}

.question-block.selected {
  border: 1px solid #1C3CD5;
}

.question-indicator {
  position: absolute;
  height: 100%;
  width: 12px;
  top: 0;
  left: 0;
  overflow: hidden;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.question-number {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #040C2D;
}

.question-title {
  font-family: euclid_regular, sans-serif;
  font-size: 10px;
  color: #344054;
  margin-top: 10px;
}

.question-list-right {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}

.bottom-actions {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
}

.add-question-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 10px 20px;
  background-color: #040C2D;
  border-radius: 12px;
  color: #FFFFFF;
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  cursor: pointer;
}

.question-select-wrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}

.question-select-wrapper span {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #040C2D;
}

.color-tool {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: help;
}

.color-tool-wrapper {
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.header-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}


.survey-container {
  width: 100%;
  border: 1px solid #EAECF0;
  border-radius: 12px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.users-sidebar {
  background-color: #fff;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  padding: 20px;
  overflow-y: auto;
  border-right: 1px solid #EAECF0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.survey-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 20px;
  gap: 10px;
}

.survey-table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.survey-table th,
.survey-table td {
  border: 1px solid #EAECF0;
  padding: 12px;
  text-align: left;
}

.survey-table th {
  background-color: #F9FAFB;
  color: #101828;
  font-weight: 500;
  min-width: 200px;
  font-family: euclid_medium, sans-serif;
  position: sticky;
  top: 0;
}

.survey-table td {
  font-size: 14px;
  color: #344054;
  font-family: euclid_regular, sans-serif;
  vertical-align: top;
}

.answers-section {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.user-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  margin-top: 10px;
}

.user-item {
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  min-width: 220px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  justify-content: center;
  align-items: flex-start;
  border-radius: 9px;
}

.user-item:hover {
  background-color: #F5F5FF;
}

.user-item.active {
  background-color: #F5F5FF;
}

.user-name {
  font-size: 14px;
  color: #101828;
  font-family: euclid_medium, sans-serif;
}

.user-email {
  font-size: 12px;
  color: #667085;
  font-family: euclid_regular, sans-serif;
}


.question-id {
  font-size: 14px;
  color: #101828;
  margin-bottom: 5px;
  font-family: euclid_medium, sans-serif;
}

.question-text {
  font-size: 14px;
  color: #667085;
  font-family: euclid_regular, sans-serif;
  margin-bottom: 10px;
}

.answers-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.answer-item {
  background-color: #FFFFFF;
  border: 1px solid #EAECF0;
  border-radius: 9px;
  padding: 15px;
}

.answer-text {
  font-size: 14px;
  color: #101828;
  padding: 10px;
  background-color: #F9FAFB;
  border-radius: 4px;
  font-family: euclid_regular, sans-serif;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 1024px) {
  .survey-container {
    flex-direction: column;
  }

  .users-sidebar {
    width: 100%;
    min-width: 100%;
    height: 300px;
    border-right: none;
    border-bottom: 1px solid #EAECF0;
  }

  .survey-table-container {
    overflow-x: auto;
  }
}

@media (max-width: 768px) {
  .wrapper {
    flex-direction: column;
  }

  .left-wrapper {
    width: 100%;
  }

  .right-wrapper {
    display: none;
    width: 100%;
  }

  .survey-wrapper {
    height: auto;
  }
}

@media print {
  .survey-container {
    display: block;
    height: auto;
  }

  .users-sidebar {
    display: none;
  }

  .survey-content {
    width: 100%;
  }

  .answers-section {
    page-break-inside: avoid;
  }

  .answer-item {
    page-break-inside: avoid;
    border: none;
    border-bottom: 1px solid #000;
    border-radius: 0;
  }
}

.no-user-selected {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #667085;
  font-family: euclid_regular, sans-serif;
}

.survey-top-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.export-excel-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  padding: 10px 20px;
  background-color: #040C2D;
  color: #FFFFFF;
  border: none;
  border-radius: 12px;
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.export-excel-btn:hover:not(:disabled) {
  background-color: #1C3CD5;
}

.export-excel-btn:disabled {
  background-color: #98A2B3;
  cursor: not-allowed;
}

.export-excel-btn img {
  width: 14px;
  height: 14px;
  filter: brightness(0) invert(1);
}

/* Responsive tasarım için */
@media (max-width: 768px) {
  .survey-top-actions {
    justify-content: center;
  }
}
</style>
